import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Box,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Button } from "@mui/base";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import {
  getServiceRegion,
  postAddSubVendorRegion,
} from "redux/actions/UserServiceCity";
import {
  getChooseYourService,
  updateChooseYourService,
} from "redux/actions/UserChooseYourService";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import CommonDialog from "components/commonDialog/CommonDialog";
import CommonModal from "components/commonModal/CommonModal";
import { dateFormate } from "utils/utils";
import pdfImg from "assets/images/pdfImg.svg";
import download from "assets/images/download.png";
import smLocation from "assets/images/moreDetailsLocation.svg";
import { commonObject } from "utils/enumObject";

function MoreDetailsDriver(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [checkboxEdit, setcheckboxEdit] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const regionSelection = useSelector(
    (state) => state?.userServiceRegion?.userServiceRegion?.data
  );
  const chooseYourServiceData = useSelector(
    (state) => state?.userChooseYourService?.userChooseYourService?.data
  );

  useEffect(() => {
    const service = {
      serviceCityId: state?.cityLocationId,
    };
    const data = {
      id: state?.companyId,
      type: "Company",
      // TODO: added harcode data backend is working on it
      businessType:commonObject.businessType
    };
    dispatch(getChooseYourService(data));
    dispatch(getServiceRegion(service));
  }, []);

  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedImage(null);
    setOpen(false);
    setEdit(false);
    setcheckboxEdit(false);
  };

  const handleOnError = (e) => {
    e.target.src = pdfImg;
  };

  const onEditButton = () => {
    setEdit(true);
  };

  const onCheckBoxButton = () => {
    setcheckboxEdit(true);
  };

  const serviceArea = [
    {
      placeholder: "Add ServiceArea",
      required: true,
      type: "text",
      name: "serviceRegions",
      label: "Add your Serviceable Area",
      star: "*",
      autoComplete: true,
    },
  ];

  const handleRedirect = (data) => {
    const filterData = {
      serviceRegions: data?.facilities,
      subvendorId: state?.companyId,
    };
    dispatch(postAddSubVendorRegion(filterData));
    setEdit(false);
  };

  const handleCheckboxChange = (serviceId) => {
    if (selectedCheckboxes.includes(serviceId)) {
      setSelectedCheckboxes(
        selectedCheckboxes.filter((id) => id !== serviceId)
      );
    } else {
      setSelectedCheckboxes([...selectedCheckboxes, serviceId]);
    }
  };

  const handleSubmit = () => {
    const dataservice = {
      id: state?.companyId,
      type: "Company",
      serviceId: selectedCheckboxes,
      status: "Active",
    };
    dispatch(updateChooseYourService(dataservice));
    setcheckboxEdit(false);
  };

  const filteredFiles = props?.subVendorMoreDetails?.filter(
    (val) => val.attributeType === "File"
  );
  const filteredImages = props?.subVendorMoreDetails?.filter(
    (val) => val.attributeType === "Image"
  );
  const filteredTextDocuments = props?.subVendorMoreDetails?.filter(
    (val) => val.attributeType === "text"
  );

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-around"
        alignItems="start"
        spacing={2}
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
          md={8.3}
          sm={12}
        >
          {props?.subVendorMoreDetails?.length === 0 ? (
            <Grid className="width100 tableMain">
              <CommonNoDataFound />
            </Grid>
          ) : (
            <>
              {filteredFiles?.length > 0 && (
                <Typography className="mb5 padding10 font18">
                  Text With File Document
                </Typography>
              )}
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                md={12}
              >
                {props.subVendorMoreDetails?.map((document, idx) => {
                  if (document?.attributeType === "File") {
                    return (
                      <Grid
                        item
                        md={5.9}
                        sm={12}
                        justifyContent="space-between"
                        className="dlImgMain borderStyle mb15 height330"
                        key={document.id}
                        onClick={() =>
                          !document?.complianceFile?.name.includes(".pdf")&& handleOpen(document?.complianceFile?.url)
                        }
                      >
                        <Grid
                          item
                          container
                          direction="row"
                          justifyContent="space-between"
                          // alignItems="center"
                          className="padding10"
                        >
                          {document?.complianceFile?.url && (
                            <img
                              src={
                                document?.complianceFile?.name.includes(
                                  ".pdf"
                                ) && document?.complianceFile?.url
                                  ? pdfImg
                                  : document?.complianceFile?.url
                              }
                              alt="driving"
                              className="dlImg"
                              onError={handleOnError}
                            />
                          )}
                          <Grid item>
                            <h1 className="colorBlack font14 fontMedium textOverflow">
                              {document?.complianceName}
                              {document?.isMandatory && (
                                <span className="colorRed">*</span>
                              )}
                            </h1>
                            {document?.atributeValue && (
                              <p className="font12 fontNormal colorGrey">
                                Number: {document?.atributeValue}
                              </p>
                            )}
                            {document?.expiryDate && (
                              <p className="font12 fontNormal colorBlue">
                                <span className="colorBlue">Exp</span>
                                {dateFormate(
                                  document?.expiryDate,
                                  "DD MMMM YYYY"
                                )}
                              </p>
                            )}
                          </Grid>
                          <Grid item>
                            <div className="colorGrey textCenter marginTop mb20">
                              {document?.complianceFile?.size}
                              <span className="marginInline10">
                                <a
                                  href={document?.complianceFile?.url}
                                  download={document?.complianceFile?.name}
                                >
                                  <img src={download} alt="download icon" />
                                </a>
                              </span>
                            </div>
                            {document?.status && (
                              <Tooltip title={document?.rejectionReason}>
                                <Typography
                                  className={` ${
                                    document?.status + "Btn"
                                  } flexDirection`}
                                >
                                  {document.status === "Rejected" && (
                                    <ErrorOutlineIcon className="marginRight3 font16" />
                                  )}
                                  {document?.status}
                                </Typography>
                              </Tooltip>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  }
                  return null;
                })}
              </Grid>

              {filteredTextDocuments?.length > 0 && (
                <div className="dashedborder width100"> </div>
              )}
              {filteredTextDocuments?.length > 0 && (
                <Typography className="mb5 padding10 font18">
                  Text Documents
                </Typography>
              )}
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                md={12}
              >
                {props.subVendorMoreDetails?.map((document, idx) => {
                  if (document?.attributeType === "text") {
                    return (
                      <Grid
                        item
                        md={5.5}
                        sm={12}
                        justifyContent="space-between"
                        className="dlImgMain borderStyle mb15"
                        key={document.id}
                      >
                        <Grid
                          item
                          container
                          direction="row"
                          justifyContent="space-between"
                          className="padding10 backgroundGrey"
                        >
                          <Grid item>
                            <h1 className="colorBlack font14 fontMedium textOverflow">
                              {document?.complianceName}
                              {document?.isMandatory && (
                                <span className="colorRed">*</span>
                              )}
                            </h1>
                            {document?.atributeValue && (
                              <p className="font12 fontNormal colorGrey">
                                Number: {document?.atributeValue}
                              </p>
                            )}
                            {document?.expiryDate && (
                              <p className="font12 fontNormal colorBlue">
                                <span className="colorBlue">Exp</span>
                                {dateFormate(
                                  document?.expiryDate,
                                  "DD MMMM YYYY"
                                )}
                              </p>
                            )}
                          </Grid>
                          <Grid item className="dflex">
                            {document?.status && (
                              <Tooltip title={document?.rejectionReason}>
                                <Typography
                                  className={` ${
                                    document?.status + "Btn"
                                  } flexDirection`}
                                >
                                  {document.status === "Rejected" && (
                                    <ErrorOutlineIcon className="marginRight3 font16" />
                                  )}
                                  {document?.status}
                                </Typography>
                              </Tooltip>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  }
                  return null;
                })}
              </Grid>
              {filteredImages?.length > 0 && (
                <div className="dashedborder width100"></div>
              )}
              {filteredImages?.length > 0 && (
                <Typography className="mb5 padding10 font18">
                  Text with MultiImage
                </Typography>
              )}
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                md={12}
              >
                {props.subVendorMoreDetails?.map((document, idx) => {
                  if (document?.attributeType === "Image") {
                    return (
                      <Grid
                        item
                        md={5.9}
                        sm={12}
                        justifyContent="space-between"
                        className="dlImgMain height330 borderStyle mb15"
                        key={document.id}
                      >
                        <Grid
                          item
                          container
                          direction="row"
                          justifyContent="space-between"
                          className="padding10"
                          onClick={() =>
                            handleOpen(document?.complianceFile?.url)
                          }
                        >
                          {document?.complianceFile?.url && (
                            <img
                              src={document?.complianceFile?.url}
                              alt="driving"
                              className="dlImg imageRendering"
                              onError={handleOnError}
                            />
                          )}
                          <Grid item>
                            <h1 className="colorBlack font14 fontMedium textOverflow">
                              {document?.complianceName}
                              {document?.isMandatory && (
                                <span className="colorRed">*</span>
                              )}
                            </h1>
                            {document?.atributeValue && (
                              <p className="font12 fontNormal colorGrey">
                                Number: {document?.atributeValue}
                              </p>
                            )}
                            {document?.expiryDate && (
                              <p className="font12 fontNormal colorBlue">
                                <span className="colorBlue">Exp</span>
                                {dateFormate(
                                  document?.expiryDate,
                                  "DD MMMM YYYY"
                                )}
                              </p>
                            )}
                          </Grid>
                          <Grid item>
                            <div className="colorGrey textCenter marginTop mb10">
                              {document?.complianceFile?.size}
                              <span className="marginInline10">
                                <a
                                  href={document?.complianceFile?.url}
                                  download={document?.complianceFile?.name}
                                >
                                  <img src={download} alt="download icon" />
                                </a>
                              </span>
                            </div>
                            {document?.status && (
                              <Tooltip title={document?.rejectionReason}>
                                <Typography
                                  className={` ${
                                    document?.status + "Btn"
                                  } flexDirection`}
                                >
                                  {document.status === "Rejected" && (
                                    <ErrorOutlineIcon className="marginRight3 font16" />
                                  )}
                                  {document?.status}
                                </Typography>
                              </Tooltip>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  }
                  return null;
                })}
              </Grid>
            </>
          )}
        </Grid>

        {/* ---Service Area--- */}
        <Grid item container md={3.3} sm={12}>
          <Grid
            item
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <h1 className="font16 fontNormal colorBlue"> Service Area</h1>
          </Grid>
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            rowSpacing={3}
          >
            {props?.subVendorLocation?.length === 0 ? (
              <p>No service areas available</p>
            ) : (
              props?.subVendorLocation?.map((ele, idx) => (
                <Grid item xs={4}>
                  <Box className="alignItem">
                    <img
                      src={smLocation}
                      alt="location"
                      className="marginInline10 "
                    />
                    <p className="font14 fontSemi">{ele?.name} </p>
                  </Box>
                </Grid>
              ))
            )}
            {props?.chooseYourServiceData?.length === 0 ? (
              <CommonNoDataFound />
            ) : (
              <Grid container className="marginTop25">
                <Grid
                  item
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <h1 className="font16 fontNormal colorBlue"> Services</h1>
                </Grid>
                <Grid container item className="margin10" direction="row">
                  {props?.chooseYourServiceData?.map(
                    (ele, id) =>
                      ele?.status === "Active" && (
                        <>
                          <Chip
                            label={ele.name}
                            variant="outlined"
                            className="margin10 colorGrey font16 forntNormal"
                          />
                        </>
                      )
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      {open && <CommonModal
        open={open}
        handleClose={handleClose}
        selectedImage={selectedImage}
      />}

      {edit ? (
        <CommonDialog
          open={edit}
          handleClose={handleClose}
          formData={serviceArea}
          button={"Add"}
          onSubmittBtn={handleRedirect}
          optionData={regionSelection}
          type={"Edit Service"}
          selectType={"edit"}
          defaultValues={props?.subVendorLocation}
        />
      ) : null}

      {checkboxEdit ? (
        <Dialog
          fullScreen={fullScreen}
          open={checkboxEdit}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <Grid container>
              <Grid item xs={12} className="dialogHead">
                <Typography className="titleStyle">
                  Edit <span className="colorSecondary">Service</span>
                </Typography>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid container>
                <Grid item xs={12} className="formPadding">
                  <FormGroup>
                    {chooseYourServiceData?.map((service, idx) => (
                      <FormControlLabel
                        key={service.id}
                        control={
                          <Checkbox
                            checked={selectedCheckboxes.includes(service.id)}
                            onChange={() => handleCheckboxChange(service.id)}
                          />
                        }
                        className="chooseCheckbox"
                        label={service?.name}
                      />
                    ))}
                  </FormGroup>
                  <Grid container>
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        size="medium"
                        className="buttonSubmit width100 borderForm cursor"
                        type="submit"
                        fullWidth
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      ) : null}
    </div>
  );
}

export default MoreDetailsDriver;
